<template>
  <div>
    <template v-if="isEditable">
      <template v-if="value == ''">
        <input
          type="file"
          :id="'file' + index"
          :ref="'file' + index"
          v-on:change="handleFileUpload()"
          style="display: none"
        />
        <button class="btn btn-secondary btn-size-medium includedIcon" @click="fileButtonClick()">
          <upload-icon />{{ uploadText }}
        </button>
        <p class="my-3">
          <small>{{ file.name }}</small>
        </p>
      </template>
      <template v-else>
        <div style="overflow: hidden" class="pt-5 mb-5">
          <a
            :href="value.signedUrl"
            target="_blank"
            style="float: left"
            class="no-underline btn btn-secondary btn-size-medium includedIcon"
          >
            <download-icon />View Uploaded File
          </a>
          <button
            class="ml-5 btn btn-secondary danger btn-size-medium includedIcon"
            style="float: left"
            @click="deleteFile()"
            v-if="login_type === 'student'"
          >
            <trash-icon />Delete File
          </button>
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="value == ''"><p class="my-5">No file uploaded</p></template>
      <template v-else>
        <a
          :href="value.signedUrl"
          target="_blank"
          class="no-underline mt-5 btn btn-secondary btn-size-medium includedIcon"
        >
          <download-icon />View Uploaded File
        </a>
      </template>
    </template>
    <vs-progress indeterminate color="primary" v-if="uploadingFile"></vs-progress>
  </div>
</template>

<script>
import theApi from '@/mixins/theApi';
import { UploadIcon, DownloadIcon, TrashIcon } from 'vue-feather-icons';

export default {
  components: {
    UploadIcon,
    DownloadIcon,
    TrashIcon,
  },
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      file: '',
      uploadingFile: false,
    };
  },
  computed: {
    uploadText() {
      if (typeof this.$props.uploadBtnText !== 'undefined') return this.$props.uploadBtnText;
      else return 'Upload File';
    },
  },
  props: ['value', 'index', 'isEditable', 'uploadBtnText', 'filetype'],
  inject: ['startFileUpload', 'endFileUpload', 'appendUploadedFileToData'],
  methods: {
    handleInput(e) {
      this.$emit('input', e);
    },
    handleFileUpload() {
      const file = document.getElementById('file' + this.index);
      const formData = new FormData();
      formData.append('file', file.files[0]);
      if (typeof this.$props.filetype !== 'undefined') {
        formData.append('filetype', this.$props.filetype);
      }
      this.uploadingFile = true;
      this.startFileUpload();
      theApi.methods
        .makeCall(false, 'experiences/activities/uploadFile', 'post', formData, null, true)
        .then(
          (data) => {
            if (data.status == 'OK') {
              //this.answers['uploaded_file_' + index] = data.url;
              //this.value = data.url;
              this.$emit('input', { url: data.url, signedUrl: data.signedUrl });
            }
            this.uploadingFile = false;
            this.appendUploadedFileToData(this.index, data.url);
            this.endFileUpload();
          },
          () => {
            this.deleteFile();
            this.uploadingFile = false;
            this.endFileUpload();
          },
        );
      this.file = file.files[0];
    },
    fileButtonClick() {
      document.getElementById('file' + this.index).click();
    },
    deleteFile() {
      //this.answers['uploaded_file_' + index] = '';
      //this.value = '';
      this.$emit('input', '');
      this.file = '';
      this.endFileUpload();
    },
  },
};
</script>
